import { useEffect, useState } from "react";
import type { RunState } from "../types/api";
import { deriveLiveStatus } from "../utils/liveStatus";

interface LiveStatusFeedProps {
  state: RunState;
}

export function LiveStatusFeed({ state }: LiveStatusFeedProps) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (state.runStatus !== "running" && state.runStatus !== "connecting") return;
    const id = window.setInterval(() => setNow(Date.now()), 400);
    return () => clearInterval(id);
  }, [state.runStatus]);

  if (state.runStatus !== "running" && state.runStatus !== "connecting") return null;

  const status = deriveLiveStatus(state, now);
  if (!status.headline) return null;

  return (
    <div className={`live-status-feed${status.waiting ? " is-waiting" : ""}`} aria-live="polite">
      <div className="live-status-row">
        <span className="live-status-dots" aria-hidden="true">
          <i />
          <i />
          <i />
        </span>
        <div className="live-status-copy">
          <p className="live-status-headline">{status.headline}</p>
          {status.detail ? <p className="live-status-detail">{status.detail}</p> : null}
        </div>
      </div>
      {state.rewrittenQuery && !state.framework ? (
        <p className="live-status-rewritten">Searching as: &ldquo;{state.rewrittenQuery}&rdquo;</p>
      ) : null}
    </div>
  );
}
